import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        color: "#D3D3D3"
    },
}));

export {useStyles};